import React from "react";
import { Field, ErrorMessage } from "formik";
import { TextField, FormHelperText } from "@mui/material";

const FIelds = ({ name, props, onInput, disabled }) => {
  return (
    <div>
      <Field
        as={TextField}
        name={name}
        fullWidth
        error={props.errors[name] && props.touched[name]}
        size="small"
        required
        onInput={
          onInput
            ? (e) => {
                // e.target.value = e.target.value.replace(/[^0-9,]/g, "");
                if (onInput) {
                  // Remove non-numeric and non-decimal characters
                  e.target.value = e.target.value.replace(/[^0-9.]/g, "");

                  // Allow only one decimal point
                  const parts = e.target.value.split(".");
                  if (parts.length > 2) {
                    e.target.value =
                      parts.slice(0, 2).join(".") + parts.slice(2).join("");
                  }

                  // Allow up to two digits after the decimal point
                  const decimalIndex = e.target.value.indexOf(".");
                  if (decimalIndex !== -1) {
                    const decimalPart = e.target.value.substring(
                      decimalIndex + 1
                    );
                    if (decimalPart.length > 2) {
                      e.target.value =
                        e.target.value.substring(0, decimalIndex + 3) +
                        e.target.value
                          .substring(decimalIndex + 3)
                          .replace(/[^0-9]/g, "");
                    }
                  }
                }
              }
            : null
        }
        disabled={disabled ? disabled : ""}
      />
      <FormHelperText sx={{ color: "#d32f2f" }}>
        <ErrorMessage name={name} />
      </FormHelperText>
    </div>
  );
};

export default FIelds;
